import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordResetService } from '../services/password-reset.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxSpinnerComponent, TranslocoModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent implements OnInit {
  email: string = '';
  emailError: string = '';
  isSubmitted: boolean = false;
  isLoading: boolean = false;
  isSuccess: boolean = false;

  constructor(
    private passwordResetService: PasswordResetService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    // Verificar se já está logado
    const token = localStorage.getItem('jwt');
    if (token) {
      this.router.navigate(['/home']);
    }
  }

  validateEmail(): boolean {
    this.emailError = '';
    
    if (!this.email) {
      this.emailError = this.transloco.translate('forgotPassword.toast.emailRequired');
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.email)) {
      this.emailError = this.transloco.translate('forgotPassword.toast.emailInvalid');
      return false;
    }

    return true;
  }

  onSubmit(): void {
    // Resetar estados anteriores
    this.isSuccess = false;
    this.emailError = '';
    this.isSubmitted = false; // Garantir que formulário fique visível até sucesso
    
    if (!this.validateEmail()) {
      // Não definir isSubmitted aqui, deixar formulário visível para mostrar erro
      return;
    }

    this.isLoading = true;
    this.spinner.show(undefined, {
      bdColor: 'rgba(0, 0, 0, 0.7)',
      size: 'medium',
      color: '#ffffff',
      type: 'ball-grid-pulse',
      fullScreen: true
    });

    this.passwordResetService.requestPasswordReset(this.email).subscribe({
      next: () => {
        // Só definir sucesso quando a API retornar sucesso
        this.isSuccess = true;
        this.isSubmitted = true;
        this.spinner.hide();
        this.isLoading = false;
        
        // Não mostrar toastr para não sobrepor a tela de sucesso
        // A mensagem já está na tela de sucesso
        // Usuário volta manualmente através do botão
      },
      error: (error) => {
        // Em caso de erro, garantir que sucesso não seja exibido
        this.isSuccess = false;
        this.isSubmitted = false;
        this.spinner.hide();
        this.isLoading = false;
        
        if (error.status === 400) {
          this.emailError = this.transloco.translate('forgotPassword.toast.emailInvalid');
          this.toastr.error(this.transloco.translate('forgotPassword.toast.emailInvalid'));
        } else if (error.status === 0 || error.status >= 500) {
          this.toastr.error(this.transloco.translate('forgotPassword.toast.connectionError'));
        } else {
          this.toastr.error(this.transloco.translate('forgotPassword.toast.sendError'));
        }
      }
    });
  }

  goToLogin(): void {
    // Redirecionar para login na aba "Usuário e Senha" (password)
    this.router.navigate(['/login'], { queryParams: { tab: 'password' } });
  }
}
